import React from 'react';
import { motion } from "framer-motion";

const RejectionModal = ({
    rejectionReason,
    setRejectionReason,
    rejectionFile,
    setRejectionFile,
    setIsRejectionModalOpen,
    handleRejectionStatus,
    fetchData
}) => {
    return (
        <motion.div
            className="z-50 fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <motion.div
                className="bg-white p-6 rounded-xl shadow-xl w-96"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
            >
                <h3 className="text-xl font-bold text-gray-800 mb-4">Rejection Details</h3>
                <textarea
                    className="w-full p-3 border rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-red-500"
                    rows="4"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    placeholder="Enter rejection reason..."
                />
                <input
                    type="file"
                    className="mt-4"
                    onChange={(e) => setRejectionFile(e.target.files[0])}
                />
                <div className="flex justify-end mt-6 space-x-2">
                    <button
                        onClick={async () => {
                            setRejectionFile(null);
                            setRejectionReason("");
                            setIsRejectionModalOpen(false);
                            await fetchData();
                        }}
                        className="px-4 py-2 bg-gray-400 text-white rounded-lg"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleRejectionStatus}
                        className="px-4 py-2 bg-red-500 text-white rounded-lg shadow"
                    >
                        Update
                    </button>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default RejectionModal;